<div class="color1 border">
  
  @if(productToOrderForm) {
    <form [formGroup]="productToOrderForm" class="demo">
      <label>REFERENCE</label>
      <input type="text" formControlName="caseId">
  
      <label>ProductId1</label>
      <input type="text" formControlName="product1">
      
      <label>q1</label>
      <input type="number" formControlName="qp1">
  
  
      <label>ProductId2</label>
      <input type="text" formControlName="product2">
      
      <label>q2</label>
      <input type="number" formControlName="qp2">
    </form>
  }

  <button (click)="createOrUpdateOrder()">Create or update order</button>

  <div>
    Order: {{orderCreated | json}}
  </div>

</div>



<hr>


<div class="color2 border">
  
  @if(addToCartForm) {
    <form [formGroup]="addToCartForm" class="demo">
      <label>REFERENCE</label>
      <input type="text" formControlName="reference">
  
      <label>orderid</label>
      <input type="text" formControlName="order1">
      
    </form>
  }

  <button (click)="addToCart()">Add to cart</button>

  <div>
    Cart: {{cartCreated | json}}
  </div>

</div>


<div class="color3 border">
  
  @if(cartIdForm) {
    <form [formGroup]="cartIdForm" class="demo">

      <label>cart Ref</label>
      <input type="text" formControlName="cartId">
      
    </form>
  }

  <button (click)="payCart()">PAY</button>

</div>



